import React, { useState } from 'react';
import { SignersStep } from '../02_signersStep/SignersStep';
import { WizardStepProps } from '../WizardStepProps';
import { CreateSigningAppointmentFormData } from '../04_confirmationStep/convertToCreateSigningAppointmentRequest';
import { useWizardStep } from '../useWizardStep';
import { ProgressStep } from '../shared/WizardProgress';
import { DetailsForm } from './detailsForm/DetailsForm';
import { DetailsStepNavigation } from './DetailsStepNavigation';
import { FormTemplate } from '../shared/FormTemplate';

export const DetailsStep: React.FC<WizardStepProps> = ({
  wizardFormData,
  isCorrection = false,
  correctionId,
  ...rest
}) => {
  const { showNext, advance } = useWizardStep();
  const [updatedWizardFormData, setUpdatedWizardFormData] = useState<CreateSigningAppointmentFormData>(wizardFormData);

  if (showNext) {
    return <SignersStep wizardFormData={updatedWizardFormData} isCorrection={isCorrection} {...rest}></SignersStep>;
  }
  return (
    <FormTemplate wizardFormData={wizardFormData} progressStep={ProgressStep.DETAILS}>
      <DetailsForm
        key={correctionId}
        advance={advance}
        isCorrection={isCorrection}
        updatedWizardFormData={updatedWizardFormData}
        setUpdatedWizardFormData={setUpdatedWizardFormData}
        {...rest}
      >
        <DetailsStepNavigation />
      </DetailsForm>
    </FormTemplate>
  );
};
